export const IFRAME_NAME = 'FNX-COM-API';
